import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=21c4e976"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"
import style0 from "./EditProfileForm.vue?vue&type=style&index=0&id=21c4e976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports